import { useLazyQuery, useMutation } from "@apollo/client";
import { useAuth } from "components/custom/authprovider";
import { PUBLIC_SEND_EMAIL } from "graphql/mutations/users";
import { FINALIZE_REGISTER } from "graphql/mutations/users";
import { PUBLIC_VERIFY_SMS } from "graphql/mutations/users";
import { PUBLIC_VERIFY_EMAIL } from "graphql/mutations/users";
import { PUBLIC_SEND_SMS } from "graphql/mutations/users";
import { PRE_REG2_CUSTOMER } from "graphql/queries/users";
import { PRE_REG1_CUSTOMER } from "graphql/queries/users";
import { useState } from "react";
import { RotatingLines } from "react-loader-spinner";
import { useHistory } from "react-router-dom";
import { stateArray } from "utils/arrays";
import { EmailAlert } from "utils/defaults";
import { SubDirectory } from "utils/defaults";
import { spinnerContainerStyle } from "utils/defaults";
import { APPCOOKIE } from "utils/defaults";
import { SMSAlert } from "utils/defaults";
import { usePackageId } from "utils/functions";
import { SAlert } from "utils/functions";
import { validateEmail } from "utils/functions";
import { validateWholeNumber } from "utils/functions";
import { SAText } from "utils/functions";
import { getDeviceFingerprint } from "utils/functions";
import { validatePhoneNumber } from "utils/functions";
import { FormatPhone } from "utils/functions";

const {
  CardHeader,
  CardBody,
  CardFooter,
  Card,
  Col,
  Row,
  FormGroup,
  Input,
  Button,
} = require("reactstrap");

function Register() {
  let history = useHistory();

  const [fielderrors, setFieldError] = useState([]);
  const [step, setStep] = useState(1);
  const [apploading, setAppLoading] = useState(false);
  const { wt, setWT, setIsAuthenticated } = useAuth();
  const packageId = usePackageId();

  const [registerdata, setRegisterData] = useState({
    firstname: "",
    lastname: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    phone: "",
    email: "",
    existingcustomer: "",
  });

  const [preReg1] = useLazyQuery(PRE_REG1_CUSTOMER, {
    context: {
      headers: {
        authorization: wt && wt.wt ? `Bearer ${wt.wt}` : "", // Include the token in the request header
        "X-Device-Fingerprint": getDeviceFingerprint(), // Include the device fingerprint in a custom header
      },
    },
    onError: (errors) => {
      if (errors.networkError) {
        const serverError = errors.networkError.result.errors[0].message;
        if (serverError === "Authentication required.") {
          history.push({ pathname: "/logout" });
        }
      }
    },
  });

  const [preReg2] = useLazyQuery(PRE_REG2_CUSTOMER, {
    context: {
      headers: {
        authorization: wt && wt.wt ? `Bearer ${wt.wt}` : "", // Include the token in the request header
        "X-Device-Fingerprint": getDeviceFingerprint(), // Include the device fingerprint in a custom header
      },
    },
    onError: (errors) => {
      if (errors.networkError) {
        const serverError = errors.networkError.result.errors[0].message;
        if (serverError === "Authentication required.") {
          history.push({ pathname: "/logout" });
        }
      }
    },
  });

  const [registerCustomer] = useMutation(FINALIZE_REGISTER, {
    onError: (errors) => {
      if (errors.networkError) {
        const serverError = errors.networkError.result.errors[0].message;
        if (serverError === "Authentication required.") {
          history.push({ pathname: "/logout" });
        }
      }
    },
  });

  const [publicSendSMS] = useMutation(PUBLIC_SEND_SMS, {
    onError: (errors) => {
      if (errors.networkError) {
        const serverError = errors.networkError.result.errors[0].message;
        if (serverError === "Authentication required.") {
          history.push({ pathname: "/logout" });
        }
      }
    },
  });

  const [publicVerifySMS] = useMutation(PUBLIC_VERIFY_SMS, {
    onError: (errors) => {
      if (errors.networkError) {
        const serverError = errors.networkError.result.errors[0].message;
        if (serverError === "Authentication required.") {
          history.push({ pathname: "/logout" });
        }
      }
    },
  });

  const [publicSendEmail] = useMutation(PUBLIC_SEND_EMAIL, {
    onError: (errors) => {
      if (errors.networkError) {
        const serverError = errors.networkError.result.errors[0].message;
        if (serverError === "Authentication required.") {
          history.push({ pathname: "/logout" });
        }
      }
    },
  });

  const [publicVerifyEmail] = useMutation(PUBLIC_VERIFY_EMAIL, {
    onError: (errors) => {
      if (errors.networkError) {
        const serverError = errors.networkError.result.errors[0].message;
        if (serverError === "Authentication required.") {
          history.push({ pathname: "/logout" });
        }
      }
    },
  });

  const UpdateRegisterData = (e, type = "") => {
    if (type !== "array") {
      let value = e.target.value;
      if (e.target.type === "number") {
        if (value === "") value = 0;
        else value = parseInt(value);
      }

      if (type === "boolean") {
        if (typeof value === "string") {
          const a = value === "true";
          value = a;
        }
      }

      setRegisterData((prevState) => {
        return { ...prevState, [e.target.name]: value };
      });
    } else {
      setRegisterData((prevState) => {
        return { ...prevState, [e.name]: e.value };
      });
    }
  };

  const CheckError = (e) => {
    if (fielderrors.length > 0) {
      const q = fielderrors.find((a) => a.field === e);
      if (q) return q.error;
      else return false;
    } else return false;
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (validateWholeNumber(value)) {
      setRegisterData((prevState) => {
        return { ...prevState, zip: value };
        // return { ...prevState, zip:parseInt(value)};
      });
    }
  };

  const LookupPhone = () => {
    let valid = true;
    setFieldError(() => []);
    if (registerdata.phone.trim() === "" || registerdata.phone === undefined) {
      valid = false;
      setFieldError((prevState) => {
        return [...prevState, { field: "phone", error: "Phone is required" }];
      });
    }

    if (!validatePhoneNumber(registerdata.phone)) {
      valid = false;
      setFieldError((prevState) => {
        return [
          ...prevState,
          { field: "phone", error: "Invalid Phone Format" },
        ];
      });
    }

    if (valid) {
      setAppLoading(true);
      preReg1({ variables: { phone: registerdata.phone } })
        .then((lookupres) => {
          if (lookupres.data.preReg1.status) {
            publicSendSMS({
              variables: {
                type: "wowcloudregister",
                phone: registerdata.phone,
              },
            })
              .then((smsres) => {
                if (smsres.data.publicSendSMS.status) {
                  SAlert(
                    SMSAlert.title,
                    "text",
                    SMSAlert.label,
                    SMSAlert.icon,
                    (v) => {
                      ConfirmPhone(v);
                    },
                  );
                } else {
                  SAText("Error", smsres.data.publicSendSMS.error, "error");
                }
              })
              .catch((err) => {
                SAText("Error", err, "error");
              })
              .finally(() => {
                setAppLoading(false);
              });
          } else {
            SAText("Error", lookupres.data.preReg1.error, "error");
          }
        })
        .catch((err) => {
          console.log("ERR", err);
          SAText(
            "Error",
            "Something isn't quite right. Please contact an adminstrator.",
            "error",
          );
        })
        .finally(() => {
          setAppLoading(false);
        });
    }
  };

  const ConfirmPhone = (code) => {
    setAppLoading(true);
    publicVerifySMS({
      variables: {
        phone: registerdata.phone,
        code: code,
        type: "wowcloudregister",
      },
    })
      .then((lookupres) => {
        if (lookupres.data.publicVerifySMS.status) {
          setStep(2);
        } else {
          SAText("Error", lookupres.data.publicVerifySMS.error, "error");
        }
      })
      .catch((err) => {
        console.log("Eaa", err);
        SAText(
          "Error",
          "Something isn't quite right. Please contact an adminstrator.",
          "error",
        );
      })
      .finally(() => {
        setAppLoading(false);
      });
  };

  const LookupEmail = () => {
    let valid = true;
    setFieldError(() => []);
    if (registerdata.email.trim() === "" || registerdata.email === undefined) {
      valid = false;
      setFieldError((prevState) => {
        return [...prevState, { field: "email", error: "Email is required" }];
      });
    }

    if (!validateEmail(registerdata.email)) {
      valid = false;
      setFieldError((prevState) => {
        return [
          ...prevState,
          { field: "email", error: "Invalid Email Format" },
        ];
      });
    }

    if (valid) {
      setAppLoading(true);
      preReg2({
        variables: { phone: registerdata.phone, email: registerdata.email },
      })
        .then((lookupres) => {
          if (lookupres.data.preReg2.status) {
            publicSendEmail({ variables: { email: registerdata.email } })
              .then((smsres) => {
                if (smsres.data.publicSendEmail.status) {
                  SAlert(
                    EmailAlert.title,
                    "text",
                    EmailAlert.label,
                    EmailAlert.icon,
                    (v) => {
                      ConfirmEmail(v, lookupres.data.preReg2.customer);
                    },
                  );
                } else {
                  SAText("Error", smsres.data.publicSendEmail.error, "error");
                }
              })
              .catch((err) => {
                SAText("Error", err, "error");
              })
              .finally(() => {
                setAppLoading(false);
              });
          } else {
            SAText("Error", lookupres.data.preReg2.error, "error");
          }
        })
        .catch((err) => {
          console.log("ERR", err);
          SAText(
            "Error",
            "Something isn't quite right. Please contact an adminstrator.",
            "error",
          );
        })
        .finally(() => {
          setAppLoading(false);
        });
    }
  };

  const ConfirmEmail = (code, regdata) => {
    setAppLoading(true);
    publicVerifyEmail({ variables: { email: registerdata.email, code: code } })
      .then((lookupres) => {
        if (lookupres.data.publicVerifyEmail.status) {
          //TODO:
          Autofill(regdata);
        } else {
          SAText("Error", lookupres.data.publicVerifyEmail.error, "error");
        }
      })
      .catch((err) => {
        console.log("Eaa", err);
        SAText(
          "Error",
          "Something isn't quite right. Please contact an adminstrator.",
          "error",
        );
      })
      .finally(() => {
        setAppLoading(false);
      });
    // setAppLoading(true)
    //TODO:Verifiy Email Code
    //TODO: Get Reg Data back on Email Confirmation intead maybe?
    // setStep(3)
    // Autofill(regdata)
  };

  const Autofill = (regdata) => {
    //Set Customer Details
    setRegisterData({
      firstname: regdata.firstname,
      lastname: regdata.lastname,
      address1: regdata.address1,
      address2: regdata.address2,
      city: regdata.city,
      state: regdata.state,
      zip: regdata.zip === 0 ? "" : regdata.zip,
      phone: registerdata.phone,
      email: registerdata.email,
      // phone: regdata.phone ? regdata.phone : registerdata.phone,
      // email: regdata.email,
      existingcustomer: regdata.existingcustomer,
    });
    setStep(3);
  };

  const TryRegister = () => {
    let valid = true;
    setFieldError(() => []);

    if (
      registerdata.firstname.trim() === "" ||
      registerdata.firstname === undefined
    ) {
      valid = false;
      setFieldError((prevState) => {
        return [
          ...prevState,
          { field: "firstname", error: "First Name is required" },
        ];
      });
    }

    if (
      registerdata.lastname.trim() === "" ||
      registerdata.lastname === undefined
    ) {
      valid = false;
      setFieldError((prevState) => {
        return [
          ...prevState,
          { field: "lastname", error: "Last Name is required" },
        ];
      });
    }

    if (registerdata.email.trim() === "" || registerdata.email === undefined) {
      valid = false;
      setFieldError((prevState) => {
        return [...prevState, { field: "email", error: "Email is required" }];
      });
    }

    if (
      registerdata.address1.trim() === "" ||
      registerdata.address1 === undefined
    ) {
      valid = false;
      setFieldError((prevState) => {
        return [
          ...prevState,
          { field: "address1", error: "Address is required" },
        ];
      });
    }

    if (registerdata.city.trim() === "" || registerdata.city === undefined) {
      valid = false;
      setFieldError((prevState) => {
        return [...prevState, { field: "city", error: "City is required" }];
      });
    }

    if (registerdata.state.trim() === "" || registerdata.state === undefined) {
      valid = false;
      setFieldError((prevState) => {
        return [...prevState, { field: "state", error: "State is required" }];
      });
    }

    if (registerdata.zip === "" || registerdata.zip === undefined) {
      valid = false;
      setFieldError((prevState) => {
        return [...prevState, { field: "zip", error: "Zip is required" }];
      });
    }

    if (!validatePhoneNumber(registerdata.phone)) {
      valid = false;
      setFieldError((prevState) => {
        return [
          ...prevState,
          { field: "phone", error: "Invalid Phone Format" },
        ];
      });
    }

    if (!validateEmail(registerdata.email)) {
      valid = false;
      setFieldError((prevState) => {
        return [
          ...prevState,
          { field: "email", error: "Invalid Email Format" },
        ];
      });
    }

    if (valid) {
      setAppLoading(true);
      FinalizeRegisterCustomer();
    }
  };

  const FinalizeRegisterCustomer = () => {
    const newData = { ...registerdata, packageid: packageId };

    setRegisterData(newData);

    registerCustomer({
      variables: { data: newData, fingerprint: getDeviceFingerprint() },
    })
      .then((fData) => {
        if (fData.data.registerCustomer.status) {
          const TheCookie = {
            wt: fData.data.registerCustomer.token,
            dt: fData.data.registerCustomer.dt,
            p: registerdata.phone,
          };
          const token = localStorage.setItem(
            APPCOOKIE,
            JSON.stringify(TheCookie),
          );

          setWT({
            wt: fData.data.registerCustomer.token,
            dt: fData.data.registerCustomer.dt,
            p: registerdata.phone,
          });

          setIsAuthenticated({ token });

          SAText("Success", "Successfully Registered.", "success", () =>
            history.push("/" + SubDirectory + "checkout/" + packageId),
          );
        } else {
          SAText("Error", fData.data.registerCustomer.error, "error", () => {
            setAppLoading(false);
            history.push("/" + SubDirectory + "register");
          });
        }
      })
      .catch((err) => {
        SAText("Error", err, "error", () => {
          setAppLoading(false);
          history.push("/" + SubDirectory + "register");
        });
      })
      .finally(() => {
        //TODO:set loading
      });
  };

  return (
    <div className="content">
      <div style={spinnerContainerStyle}>
        <RotatingLines
          height="280"
          width="280"
          color="#4fa94d"
          radius="1"
          wrapperStyle={{}}
          wrapperClass=""
          visible={apploading}
        />
      </div>

      {!apploading && registerdata && (
        <Row>
          <Col md="12">
            <Card>
              <CardHeader className="subTitle">
                WOW Cloud Network Checkout
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md="12">
                    <Card style={{ width: "90%", margin: "0 auto" }}>
                      <CardHeader className="subTitle">Registration</CardHeader>
                      {step === 1 && (
                        <CardBody>
                          <Row>
                            <Col md="12">
                              <FormGroup>
                                <label className="subTitle">* Phone:</label>
                                <Input
                                  placeholder="Phone"
                                  type="text"
                                  name="phone"
                                  value={registerdata.phone}
                                  onChange={(e) =>
                                    FormatPhone(e, setRegisterData)
                                  }
                                  autoComplete="off"
                                  maxLength={60}
                                  className={CheckError("phone") ? "error" : ""}
                                />
                                <span className="errorMessage">
                                  {CheckError("phone")
                                    ? CheckError("phone")
                                    : ""}
                                </span>
                              </FormGroup>
                            </Col>
                          </Row>
                        </CardBody>
                      )}
                      {step === 2 && (
                        <CardBody>
                          <Row>
                            <Col md="12">
                              <FormGroup>
                                <label className="subTitle">* Email:</label>
                                <Input
                                  placeholder="Email"
                                  type="text"
                                  name="email"
                                  value={registerdata.email}
                                  onChange={(e) => UpdateRegisterData(e)}
                                  autoComplete="off"
                                  maxLength={60}
                                  className={CheckError("email") ? "error" : ""}
                                />
                                <span className="errorMessage">
                                  {CheckError("email")
                                    ? CheckError("phone")
                                    : ""}
                                </span>
                              </FormGroup>
                            </Col>
                          </Row>
                        </CardBody>
                      )}
                      {step === 3 && (
                        <CardBody>
                          <Row>
                            <Col md="6">
                              <FormGroup>
                                <label className="subTitle">
                                  * First Name:
                                </label>
                                <Input
                                  placeholder="First Name"
                                  type="text"
                                  name="firstname"
                                  value={registerdata.firstname}
                                  onChange={(e) => UpdateRegisterData(e)}
                                  autoComplete="off"
                                  maxLength={30}
                                  className={
                                    CheckError("firstname") ? "error" : ""
                                  }
                                />
                                <span className="errorMessage">
                                  {CheckError("firstname")
                                    ? CheckError("firstname")
                                    : ""}
                                </span>
                              </FormGroup>
                            </Col>
                            <Col md="6">
                              <FormGroup>
                                <label className="subTitle">* Last Name:</label>
                                <Input
                                  placeholder="Last Name"
                                  type="text"
                                  name="lastname"
                                  value={registerdata.lastname}
                                  onChange={(e) => UpdateRegisterData(e)}
                                  autoComplete="off"
                                  maxLength={30}
                                  className={
                                    CheckError("lastname") ? "error" : ""
                                  }
                                />
                                <span className="errorMessage">
                                  {CheckError("lastname")
                                    ? CheckError("lastname")
                                    : ""}
                                </span>
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row>
                            <Col md="6">
                              <FormGroup>
                                <label className="subTitle">* Phone:</label>
                                <Input
                                  placeholder="Phone"
                                  type="text"
                                  name="phone"
                                  readOnly={true}
                                  value={registerdata.phone}
                                  onChange={(e) =>
                                    FormatPhone(e, setRegisterData)
                                  }
                                  autoComplete="off"
                                  maxLength={60}
                                  className={CheckError("phone") ? "error" : ""}
                                />
                                <span className="errorMessage">
                                  {CheckError("phone")
                                    ? CheckError("phone")
                                    : ""}
                                </span>
                              </FormGroup>
                            </Col>
                            <Col md="6">
                              <FormGroup>
                                <label className="subTitle">* Email:</label>
                                <Input
                                  placeholder="Email"
                                  type="text"
                                  readOnly={true}
                                  name="email"
                                  value={registerdata.email}
                                  onChange={(e) => UpdateRegisterData(e)}
                                  autoComplete="off"
                                  maxLength={60}
                                  className={CheckError("email") ? "error" : ""}
                                />
                                <span className="errorMessage">
                                  {CheckError("email")
                                    ? CheckError("email")
                                    : ""}
                                </span>
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row>
                            <Col md="6">
                              <FormGroup>
                                <label className="subTitle">* Address:</label>
                                <Input
                                  placeholder="Address"
                                  type="text"
                                  name="address1"
                                  value={registerdata.address1}
                                  onChange={(e) => UpdateRegisterData(e)}
                                  autoComplete="off"
                                  maxLength={60}
                                  className={
                                    CheckError("address1") ? "error" : ""
                                  }
                                />
                                <span className="errorMessage">
                                  {CheckError("address1")
                                    ? CheckError("address1")
                                    : ""}
                                </span>
                              </FormGroup>
                            </Col>
                            <Col md="6">
                              <FormGroup>
                                <label className="subTitle">Address 2:</label>
                                <Input
                                  placeholder="Address2"
                                  type="text"
                                  name="address2"
                                  value={registerdata.address2}
                                  onChange={(e) => UpdateRegisterData(e)}
                                  autoComplete="off"
                                  maxLength={30}
                                  className={
                                    CheckError("address2") ? "error" : ""
                                  }
                                />
                                <span className="errorMessage">
                                  {CheckError("address2")
                                    ? CheckError("address2")
                                    : ""}
                                </span>
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row>
                            <Col md="6">
                              <FormGroup>
                                <label className="subTitle">* City:</label>
                                <Input
                                  placeholder="City"
                                  type="text"
                                  name="city"
                                  value={registerdata.city}
                                  onChange={(e) => UpdateRegisterData(e)}
                                  autoComplete="off"
                                  maxLength={20}
                                  className={CheckError("city") ? "error" : ""}
                                />
                                <span className="errorMessage">
                                  {CheckError("city") ? CheckError("city") : ""}
                                </span>
                              </FormGroup>
                            </Col>
                            <Col md="6">
                              <FormGroup>
                                <label className="subTitle">* State:</label>
                                <select
                                  className={
                                    (CheckError("state") ? "error" : "") +
                                    " form-control"
                                  }
                                  name="state"
                                  value={registerdata.state}
                                  onChange={(e) => UpdateRegisterData(e)}
                                  maxLength={2}
                                >
                                  <option value="">Select State</option>
                                  {stateArray.map((value, key) => {
                                    return (
                                      <option
                                        value={value.abbreviation}
                                        key={key}
                                      >
                                        {value.name}
                                      </option>
                                    );
                                  })}
                                </select>
                                <span className="errorMessage">
                                  {CheckError("state")
                                    ? CheckError("state")
                                    : ""}
                                </span>
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row>
                            <Col md="6">
                              <FormGroup>
                                <label className="subTitle">* Zip:</label>
                                <Input
                                  placeholder="Zip"
                                  type="text"
                                  name="zip"
                                  value={registerdata.zip}
                                  onChange={handleInputChange}
                                  autoComplete="off"
                                  maxLength={7}
                                  className={CheckError("zip") ? "error" : ""}
                                />
                                <span className="errorMessage">
                                  {CheckError("zip") ? CheckError("zip") : ""}
                                </span>
                              </FormGroup>
                            </Col>
                          </Row>
                        </CardBody>
                      )}
                      <CardFooter>
                        {step === 1 && (
                          <Button
                            className="btn-fill"
                            color="info"
                            type="button"
                            style={{ width: "100%" }}
                            onClick={() => LookupPhone()}
                          >
                            Continue Registration
                          </Button>
                        )}
                        {step === 2 && (
                          <Button
                            className="btn-fill"
                            color="info"
                            type="button"
                            style={{ width: "100%" }}
                            onClick={() => LookupEmail()}
                          >
                            Continue Registration
                          </Button>
                        )}

                        {step === 3 && (
                          <Button
                            className="btn-fill"
                            color="info"
                            type="button"
                            style={{ width: "100%" }}
                            onClick={() => TryRegister()}
                          >
                            Finish Registration
                          </Button>
                        )}
                      </CardFooter>
                    </Card>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </div>
  );
}

export default Register;
